import React from 'react';
import Container from '@components/atoms/Container';
import IconLink from '@components/atoms/IconLink';
import TrackingLink from '@components/atoms/TrackingLink';
import LanguagePicker from '@components/organisms/LanguagePicker';
import NewsletterSignup from '@components/organisms/NewsletterSignup';
import UsSiteModal from '@components/organisms/UsSiteModal';
import {defaultLanguageInfo} from '@helpers/getLanguageInfo';
import {useLanguageContext} from '@helpers/LanguageContext';
import footerSettings from '@netlify/site-settings/footer.yml';
import socialLinks from '@netlify/site-settings/social-media-links.yml';
/* eslint-disable */
import LogoInverted from '-!svg-react-loader!@images/hudl-logo-inverted.svg';
import IconNewWindow from '-!svg-react-loader!@images/icon-new-window.svg';
import IconTwitter from '-!svg-react-loader!@images/icon-twitter.svg';
import IconFacebook from '-!svg-react-loader!@images/icon-facebook.svg';
import IconInstagram from '-!svg-react-loader!@images/icon-instagram.svg';
import IconLinkedIn from '-!svg-react-loader!@images/icon-linkedin.svg';
/* eslint-enable */

import './style.footer.scss';

const Footer = () => {
    const {pageLanguageName} = useLanguageContext();

    const listLink = (menuItem, index) => {
        let {path} = menuItem;
        if (typeof path === 'object') {
            if (typeof path[defaultLanguageInfo.languageCode] === 'undefined') {
                return null;
            }

            path = path[defaultLanguageInfo.languageCode];
        }

        return (
            <li key={index.toString()}>
                {
                    menuItem.newWindow
                        ? (
                            <IconLink to={path} external={menuItem.external} newWindow={menuItem.newWindow}>
                                <span>{menuItem.label}</span>
                                <IconNewWindow />
                            </IconLink>
                        )
                        : <TrackingLink component="footer_list_item" to={path}>{menuItem.label}</TrackingLink>
                }
            </li>
        );
    };

    const socialLink = (menuItem, index) => {
        let icon = null;
        switch (menuItem.label) {
        case 'Twitter':
            icon = <IconTwitter />;
            break;
        case 'Facebook':
            icon = <IconFacebook />;
            break;
        case 'Instagram':
            icon = <IconInstagram />;
            break;
        case 'LinkedIn':
            icon = <IconLinkedIn />;
            break;
        default:
            throw new Error(`Social Link type: ${menuItem.label} not found.`);
        }
        return (
            <li key={index.toString()}>
                <TrackingLink to={menuItem.url} newPage={menuItem.newWindow.toString()}>
                    {icon}
                </TrackingLink>
            </li>
        );
    };

    const nav1 = footerSettings[pageLanguageName].footerNav1.map(listLink);
    const nav2 = footerSettings[pageLanguageName].footerNav2.map(listLink);
    const nav3 = footerSettings[pageLanguageName].footerPostNav.map(listLink);
    const social = socialLinks[pageLanguageName].map(socialLink);

    return (
        <>
            <NewsletterSignup />
            <footer className="hudl-footer">
                <Container>
                    <div className="hudl-footer__column">
                        <LogoInverted className="hudl-footer__logo" />
                    </div>
                    <div className="hudl-footer__column hudl-footer__column--list">
                        <nav>
                            <ul>
                                {nav1}
                            </ul>
                        </nav>
                    </div>
                    <div className="hudl-footer__column hudl-footer__column--list">
                        <nav>
                            <ul>
                                {nav2}
                            </ul>
                        </nav>
                    </div>
                    <div className="hudl-footer__column">
                        <nav>
                            <ul>
                                <li>
                                    <UsSiteModal />
                                </li>
                                <li>
                                    <LanguagePicker />
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="hudl-footer__copyright-bar">
                        <div className="hudl-footer__copyright-bar--left-side">
                            <nav>
                                <ul className="hudl-footer__copyright-bar__links">
                                    {nav3}
                                </ul>
                            </nav>
                            <p className="hudl-footer-intro">{footerSettings[pageLanguageName].brandDescription}</p>
                        </div>
                        <div className="hudl-footer__copyright-bar--right-side">
                            <nav>
                                <ul>
                                    {social}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </Container>
            </footer>
        </>
    );
};

Footer.defaultProps = {
    type: 'footer'
};

export default Footer;
